import * as React from "react";
import { authIdentify, userRegister } from "../../../services/user.service";
import { useEffect } from "react";
import { useRouter } from "../../../context/Router";
import { useTranslation } from "react-i18next";
import "./silkAuthScreenStyles.css";
import { getIdForSTB } from "../../../utils/Helpers";
import { useAuth } from "../../../context/Auth";
export var SilkAuthScreen = function () {
    var t = useTranslation().t;
    var navigate = useRouter().navigate;
    var dispatch = useAuth().dispatch;
    var accountId = getIdForSTB("accountId", "user_id");
    var stbId = getIdForSTB("stbId", "stb_id");
    useEffect(function () {
        if (!accountId || !stbId) {
            navigate("auth-cavea");
            return;
        }
        userRegister(stbId, accountId)
            .then(function () {
            authIdentify(stbId, accountId)
                .then(function (data) {
                dispatch({ type: "LOGIN", user: data });
            })
                .catch(function (e) {
                navigate("auth");
            });
        })
            .catch(function (e) {
            navigate("auth");
        });
    }, []);
    return (React.createElement("div", { className: "auth-loading-container" },
        React.createElement("div", { className: "logo-container" }),
        React.createElement("p", { className: "loading" }, t("auth_tv.loading"))));
};



//////////////////
// WEBPACK FOOTER
// ./src/screens/AuthScreen/SilkAuth/SilkAuthScreen.tsx
// module id = 173
// module chunks = 1